import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSelectSubAccount = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0656 8.19177C16.1998 8.13254 16.3138 8.03522 16.3933 7.91187C16.4728 7.78852 16.5143 7.64456 16.5128 7.49782C16.5113 7.35108 16.4668 7.20801 16.3847 7.08633C16.3027 6.96465 16.1868 6.86971 16.0513 6.81327L9.62308 3.88527C9.42766 3.79613 9.21537 3.75 9.00058 3.75C8.78579 3.75 8.5735 3.79613 8.37808 3.88527L1.95058 6.81027C1.81706 6.86875 1.70347 6.96487 1.62371 7.08688C1.54394 7.20889 1.50146 7.3515 1.50146 7.49727C1.50146 7.64304 1.54394 7.78565 1.62371 7.90766C1.70347 8.02967 1.81706 8.12579 1.95058 8.18427L8.37808 11.1153C8.5735 11.2044 8.78579 11.2505 9.00058 11.2505C9.21537 11.2505 9.42766 11.2044 9.62308 11.1153L16.0656 8.19177Z",
			stroke: "#6A7282",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 7.5V12",
			stroke: "#6A7282",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 9.375V12C4.5 12.5967 4.97411 13.169 5.81802 13.591C6.66193 14.0129 7.80653 14.25 9 14.25C10.1935 14.25 11.3381 14.0129 12.182 13.591C13.0259 13.169 13.5 12.5967 13.5 12V9.375",
			stroke: "#6A7282",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSelectSubAccount;
